@let currentCopy = copy();
@let currentStep = step();


@if(isLoading()) {
  <bw-spinner-legacy></bw-spinner-legacy>
}

@if (currentCopy && step()?.key !== 'welcome') {
  <brightside-web-display-campaign
    [campaign]="currentCopy"
    [analyticsAttributes]="{event_name: currentCopy.event_name ?? '' }"
    [showBackArrow]="currentCopy.showBackButton ?? true"
  >
  </brightside-web-display-campaign>
}

@if (step()?.key === 'welcome') {
 <brightside-web-onboarding-welcome
  (advanceStep)="advance()"
 ></brightside-web-onboarding-welcome>
}

<router-outlet></router-outlet>
